export default {"src":"/_next/static/media/Company7.aac33d91.svg","height":60,"width":120,"blurWidth":0,"blurHeight":0};